class FullPageLoaderService {

    constructor() {
        this.show = false;
    }
}

export default FullPageLoaderService;